import { Plus } from 'lucide-react';
import { Button } from '@/shared/components/ui/button';

interface EntryRulesHeaderProps {
  onAdd: () => void;
  canAdd: boolean;
}

export function EntryRulesHeader({ onAdd, canAdd }: EntryRulesHeaderProps) {
  return (
    <div className="flex items-center justify-between">
      <h1 className="text-2xl font-semibold text-gray-900">Правила въезда</h1>
      <Button onClick={onAdd} disabled={!canAdd}>
        <Plus className="h-4 w-4" />
        Добавить правило
      </Button>
    </div>
  );
}
